import React, { FC, useRef, useEffect } from 'react';
import { Divider, Radio, Table } from 'antd';
import { useAdministrationProjectsContext } from '../../containers/AdministrationProjectsContainer/AdministrationProjectsContext';
import { ProjectTableRecord } from '../../lib/interfaces/Project';
import { getDictionaryItemById } from '../../lib/utils/applications';
import { checkIsLoading } from '../../lib/utils/checkLoadingStatus';
import { useAppSelector } from '../../store/hooks';
import { Scroll } from './interfaces';

interface IProps {
  dataSource: ProjectTableRecord[];
  scroll: Scroll;
}

export const ProjectsTable: FC<IProps> = ({ dataSource, scroll }) => {
  const ref = useRef<any>(null);
  const { saveCurrentProjectId } = useAdministrationProjectsContext();
  const { projectsLoading } = useAppSelector((state) => state.projects);
  const { projectType } = useAppSelector((state) => state.dictionaries);

  // Перемещение скролла, чтобы выбранный проект был в видимой части
  useEffect(() => {
    if (ref?.current?.input) {
      ref.current.input.scrollIntoView({ block: 'nearest' });
    }
  }, []);

  const projectColumns = [
    {
      key: 'checked',
      dataIndex: 'checked',
      render: (checked: boolean) => <Radio checked={checked} ref={checked ? ref : null} />,
      width: '28px',
    },
    {
      title: 'Проект',
      key: 'title',
      dataIndex: 'title',
    },
    {
      title: 'Статус',
      key: 'projectTypeId',
      dataIndex: 'projectTypeId',
      render: (projectTypeId) => getDictionaryItemById(projectType, projectTypeId)?.name,
      width: '25%',
    },
  ];

  return (
    <div>
      <h4 className="text-bold font-size-18 mb2">Проекты</h4>
      <Divider className="thin-divider mt0 mb1" />
      <Table
        size="small"
        loading={checkIsLoading(projectsLoading)}
        columns={projectColumns}
        dataSource={dataSource}
        className="striped-table"
        rowClassName={(r, i) => (i % 2 ? 'cursor-pointer' : 'cursor-pointer striped-table__oddRow')}
        pagination={false}
        onRow={({ id }) => ({
          onClick: () => {
            saveCurrentProjectId(id);
          },
        })}
        scroll={scroll}
      />
    </div>
  );
};
